export default class SystemMessageOption {
    constructor(text, callback) {
        this.text = text;
        this.callback = callback;
    }
}